import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=0b06f5df&"
import script from "./nav-bar.vue?vue&type=script&lang=ts&"
export * from "./nav-bar.vue?vue&type=script&lang=ts&"
import style0 from "./nav-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports